<template>
  <b-card no-body>
    <b-card-header>
      <div>
        <b-card-title class="mb-1">Audience growth over time</b-card-title>
      </div>

      <!-- <div class="d-flex align-items-center calender">
        <feather-icon icon="CalendarIcon" size="16" />
        <flat-pickr
        @click.native="blurPicker"
          v-model="rangePicker"
          :config="{ mode: 'range' }"
          class="form-control flat-picker bg-transparent border-0 shadow-none"
          placeholder="YYYY-MM-DD"
        />
      </div> -->
    </b-card-header>

    <b-card-body class="pb-0">
      <div v-if="loading">
        <div class="d-flex align-items-center" v-for="i in 2" :key="i">
          <b-skeleton width="10%" height="30px" class="mr-2" />
          <b-skeleton width="75%" height="30px" />
        </div>
      </div>
      <vue-apex-charts
        v-else-if="lineAreaChartSpline.series"
        type="area"
        height="300"
        class="w-100"
        :options="lineAreaChartSpline.chartOptions"
        :series="lineAreaChartSpline.series"
      />
      <template v-else>
        <div
          class="d-flex align-items-center justify-content-center h-100 new-alert"
        >
          <b-alert
            show
            variant="secondary"
            class="d-flex align-items-center justify-content-center p-3 w-100"
          >
            no information
          </b-alert>
        </div>
      </template>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BCardTitle,
  BCardSubTitle,
  BSkeleton,
  BAlert,
} from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
// import flatPickr from "vue-flatpickr-component";

export default {
  components: {
    BCard,
    VueApexCharts,
    BCardHeader,
    BCardBody,
    BCardTitle,
    BCardSubTitle,
    // flatPickr,
    BSkeleton,
    BAlert,
  },

  data() {
    const area = {
      series3: "#a4f8cd",
      series2: "#60f2ca",
      series1: "#2bdac7",
    };
    return {
      loading: false,

      audienceGrowth: [],

      // rangePicker: "2022-12-1 to 2022-12-20",
    };
  },

  computed: {
    lineAreaChartSpline() {
      return {
        series: [
          {
            name: "Total",
            data: [
              ...this.audienceGrowth.growth_participants.map((item) => {
                return item.count;
              }),
            ],
          },
        ],

        chartOptions: {
          chart: {
            toolbar: {
              show: false,
            },
          },
          dataLabels: {
            color: "#fff",
            enabled: false,
          },
          stroke: {
            show: false,
            curve: "straight",
          },
          legend: {
            show: true,
            position: "top",
            horizontalAlign: "left",
            fontSize: "14px",
            fontFamily: "Montserrat",
            color: "#fff",
            labels: {
              colors: "#fff",
              useSeriesColors: false,
            },
          },
          grid: {
            xaxis: {
              lines: {
                show: true,
              },
            },
          },
          xaxis: {
            categories: [
              ...this.audienceGrowth.growth_participants.map((item) => {
                return item.date;
              }),
            ],
          },
          yaxis: {
            // opposite: isRtl
            color: "#fff",
          },
          fill: {
            opacity: 1,
            type: "solid",
          },
          tooltip: {
            shared: false,
          },
          colors: ["#60f2ca"],
        },
      };
    },
  },

  created() {
    this.getAudienceGrowth();
  },
  methods: {
    async getAudienceGrowth(query) {
      this.loading = true;
      try {
        const { data } = await this.$http.get(
          `/panel/competitions/${this.$route.params.id}/growth-participants` +
            (query ? query : "")
        );
        this.audienceGrowth = data;
        // this.audienceGrowth.map((item) => {
        //   this.total += item.profit;
        // });
      } catch (err) {}
      this.loading = false;
    },
  },
};
</script>
<style scoped>
.form-control {
  background-color: transparent !important;
  border: none !important;
  padding: 1rem;
}
</style>
